import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getViewAndUpdatePaymentMethodsCTA } from "./shared";

export const PaymentProcessingErrorIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return PAYMENT_PROCESSING_ERROR(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [
        PAYMENT_PROCESSING_ERROR_INTRO(strictLocalize),
        ERROR_QUESTION_1(strictLocalize),
        ERROR_QUESTION_2(strictLocalize),
        ERROR_QUESTION_3(strictLocalize),
        ERROR_QUESTION_4(strictLocalize),
        UPDATE_PAYMENT_METHOD_USING_BUTTON(strictLocalize),
      ];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(
          context,
          strictLocalize
        )?.getLink?.();
      },
    },
  };
};

const PAYMENT_PROCESSING_ERROR = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Payment processing errors",
    description: {
      text: "Title for the answer about errors while processing payments",
    },
  });

const PAYMENT_PROCESSING_ERROR_INTRO = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If there is a technical issue blocking your payment, please check the following details.",
    description: {
      text: "Description for the answer about errors while processing payments",
    },
  });

const ERROR_QUESTION_1 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "1. Does the address associated with the card match the address on your account?",
    description: {
      text: "Description/question for the answer about errors while processing payments",
    },
  });

const ERROR_QUESTION_2 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "2. Is the name on the card the same as the name listed on your Faire Account?",
    description: {
      text: "Description/question for the answer about errors while processing payments",
    },
  });

const ERROR_QUESTION_3 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "3. Is the card expired?",
    description: {
      text: "Description/question for the answer about errors while processing payments",
    },
  });

const ERROR_QUESTION_4 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "4. Does the card have any alerts on it with the bank?",
    description: {
      text: "Description/question for the answer about errors while processing payments",
    },
  });

const UPDATE_PAYMENT_METHOD_USING_BUTTON = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can update your payment methods using the button below. If your issue still persists, please contact us. When you write in, please confirm if this is a debit or credit card.",
    description: {
      text: "Description for the answer about errors while processing payments",
    },
  });
